import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import SiteHeader from "./Components/Layout/SiteHeader";
import SiteFooter from "./Components/Layout/SiteFooter";
import ScrollToTop from "./Components/Layout/ScrollToTop";
import HomePage from "./pages/Home/HomePage";
import ServicesPage from "./pages/Services/ServicesPage";
import WorkPage from "./pages/Work/WorkPage";
import AboutPage from "./pages/About/AboutPage";
import TechnologiesPage from "./pages/Technologies/TechnologiesPage";
import ContactPage from "./pages/Contact/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <div className="is-app">
        <ScrollToTop />
        <SiteHeader />
        <main>
          {/* Routes match case-insensitively, so /Services and /Technologies
              from the old site already resolve here. */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/technologies" element={<TechnologiesPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Old URLs keep working */}
            <Route path="/Home" element={<Navigate replace to="/" />} />
            <Route path="/AboutUs" element={<Navigate replace to="/about" />} />
            <Route path="/ContactUs" element={<Navigate replace to="/contact" />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </main>
        <SiteFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;
